import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListTable";
import getColor from "@insite/mobius/utilities/getColor";

const headerStyles = css`
    background: white;
    font-size: 14px;
    font-weight: 700;
    color: ${getColor("text.accent")};
    border-bottom: 1px solid ${getColor("common.border")};
    border-top: 1px solid ${getColor("common.border")};
`;

actionsStyles.descriptionHeader = mergeToNew(actionsStyles.descriptionHeader, {
    css: headerStyles,
});

actionsStyles.availabilityHeader = mergeToNew(actionsStyles.availabilityHeader, {
    css: headerStyles,
});

actionsStyles.priceHeader = mergeToNew(actionsStyles.priceHeader, {
    css: headerStyles,
});

actionsStyles.unitOfMeasureHeader = mergeToNew(actionsStyles.unitOfMeasureHeader, {
    css: headerStyles,
});

actionsStyles.attributesHeader = mergeToNew(actionsStyles.attributesHeader, {
    css: headerStyles,
});

actionsStyles.actionsHeader = mergeToNew(actionsStyles.actionsHeader, {
    css: css`
        position: sticky;
        right: 0;
        width: 200px;
        background-clip: padding-box;
        background: white;
        font-size: 14px;
        font-weight: 700;
        color: ${getColor("text.accent")};
        border-bottom: 1px solid ${getColor("common.border")};
        border-top: 1px solid ${getColor("common.border")};
    `,
});
